import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

import {Subject} from 'rxjs';


import {OrganizationUser} from '../../../afb-api/models/organization-user';
import {debounceTime} from 'rxjs/internal/operators';

@Component({
  selector: 'awair-invite-input',
  templateUrl: './invite-input.component.html',
  styleUrls: ['./invite-input.component.scss']
})

export class InviteInputComponent implements OnInit {
  @ViewChild('emailInput') emailInputRef;
  @Output() add: EventEmitter<string> = new EventEmitter();
  myEmail: string = '';
  errMsg: string = '';
  isError: boolean = false;
  isValid: boolean = false;
  isTyping: boolean = false;

  get inviteeList(): string[] {
    return this._inviteeList;
  }
  @Input()
  set inviteeList(value: string[]) {
    if (value != null) {
      this._inviteeList = [...value];
    }
  }
  private _inviteeList: string[];

  get orgUserList(): OrganizationUser[] {
    return this._orgUserList;
  }
  @Input()
  set orgUserList(value: OrganizationUser[]) {
    if (value != null) {
      this._orgUserList = [...value];
    }
  }
  private _orgUserList: OrganizationUser[];

  get pendingAdminList(): OrganizationUser[] {
    return this._pendingAdminList;
  }
  @Input()
  set pendingAdminList(value: OrganizationUser[]) {
    if (value != null) {
      this._pendingAdminList = [...value];
    }
  }
  private _pendingAdminList: OrganizationUser[];

  get pendingMemberList(): OrganizationUser[] {
    return this._pendingMemberList;
  }
  @Input()
  set pendingMemberList(value: OrganizationUser[]) {
    if (value != null) {
      this._pendingMemberList = [...value];
    }
  }
  private _pendingMemberList: OrganizationUser[];

  private emailInputChanged: Subject<string> = new Subject<string>();

  constructor() {
  }

  ngOnInit() {
    // Put typing delay on email input
    this.emailInputChanged.pipe(
      debounceTime(300)
    ).subscribe((input: string) => {
        this.isTyping = false;
        this.validateEmail(input);
      });
  }

  onChangeEmail(email: string): void {
    this.isTyping = true;
    this.isError = false;

    this.emailInputChanged.next(email);
  }

  validateEmail(email: string): void {
    // Regex taken from http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    // Test on http://jsfiddle.net/ghvj4gy9/embedded/result,js/
    const emailRegex: RegExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const lowerCaseEmail: string = email.toLowerCase();

    // Set error message
    if (!emailRegex.test(lowerCaseEmail)) {
      this.errMsg = 'This is not a valid e-mail format';

    } else if (this.pendingAdminList != null && this.pendingAdminList.map(
      (pendingAdmin: OrganizationUser) => pendingAdmin.email).indexOf(email) !== -1) {
      this.errMsg = 'Invited as Admin but still pending';

    } else if (this.pendingMemberList != null && this.pendingMemberList.map(
      (pendingMember: OrganizationUser) => pendingMember.email).indexOf(email) !== -1) {
      this.errMsg = 'Invited as Member but still pending';

    } else if (this.inviteeList.indexOf(lowerCaseEmail) !== -1) {
      this.errMsg = 'Already in invitation list';

    } else if (this.orgUserList.map((orgUser: OrganizationUser) => orgUser.email).indexOf(lowerCaseEmail) !== -1) {
      this.errMsg = 'Already an organization member';

    } else {
      this.errMsg = '';
    }

    // Set flag
    [this.isError, this.isValid] = this.errMsg === '' ? [false, true] : [true, false];
  }

  enter(email: string): void {
    if (email && !this.isError && !this.isTyping) {
      // Add after changing email to lowercase
      const lowerCaseEmail: string = email.toLowerCase();
      this.add.emit(lowerCaseEmail);

      // Reset valid message after enter
      this.emailInputRef.nativeElement.value = '';
      this.isValid = false;
    }
  }
}
